import request from '@/utils/request';

const requestInstance = request();

/**
 * 获取当前登录用户服务列表，包含未开通
 * @returns {*}
 */
export function getApiCascader() {
  return requestInstance.post('/api/apiInfo/getApiCascader');
}

/**
 * 一键激活未分配服务包
 * @returns {*}
 */
export function getErrorLogListByPage(parameter) {
  return requestInstance.post('/api/errorLog/listByPage', parameter);
}

/**
 * 获取当前登录用户企业的推送类型列表
 * @returns {*}
 */
export function getNotificationTaskType() {
  return requestInstance.post('/api/Config/getNotificationTaskTypeResult');
}


/**
 * 任务分页获取
 * @returns {*}
 */
export function getTaskLogListByPage(parameter) {
  return requestInstance.post('/api/messageNotificationTask/listTaskByPage', parameter);
}

/**
 * 重置任务
 * @returns {*}
 */
export function updateTask(parameter) {
  return requestInstance.post('/api/messageNotificationTask/updateTask', parameter);
}

/**
 * 消息重推
 * @returns {*}
 */
export function messagePushAgain(parameter) {
  return requestInstance.post('/api/messageNotificationTask/batchResetTask', parameter);
}
